import type { IconType } from "./icon-types";
import spriteSVG from "./svg-icon-sprite.svg";

class SvgIcon extends HTMLElement {
    private _icon!: IconType;
    private _size?: string | string[] | null;
    private _color?: string | null;
    private _accent?: string | null;
    private _class?: string | null;

    static get observedAttributes() {
        return ["icon", "size", "color", "accent", "classes"];
    }

    attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null): void {
        if (name === "icon") {
            this._icon = newValue as IconType;
        } else if (name === "size") {
            if (newValue?.includes(",")) {
                this._size = newValue.split(",");
            } else {
                this._size = newValue ? [newValue, newValue] : null;
            }
        } else if (name === "color") {
            this._color = `--base-icon-color: ${newValue};`;
        } else if (name === "accent") {
            this._accent = `--secondary-icon-color: ${newValue};`;
        } else if (name === "class") {
            this._class = newValue;
        }
        this.render();
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.innerHTML = `
                <i style="position:relative; ${this._color ?? ""} ${this._accent ?? ""}"
                    aria-hidden="true">
                <svg part="icon"
                     preserveAspectRatio="xMidYMid meet"
                     class="${this._class ?? ""}"
                     style="block-size: ${this._size ? this._size[0] : "1em"};
                        inline-size: ${this._size ? this._size[1] : "1em"};
                        isolation: isolate;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        line-height: ${this._size ? this._size[0] : "1em"};">
                    <use
                        id="icon-${this._icon ?? ""}"
                        xlink:href="${spriteSVG}#icon-${this._icon ?? ""}"></use>
                </svg>
                </i>
            `;
    }
}

customElements.define("svg-icon", SvgIcon);
